import { useCallback } from 'react';
import { NewsService } from 'api/news/service';

export const useNews = () => {
    const onGetAllNews = useCallback(async () => {
        try {
            const response = await NewsService.getInstance().findAll();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Добавляем useCallback с пустым массивом зависимостей

    const onGetOneNews = useCallback(async (id: number) => {
        try {
            const response = await NewsService.getInstance().findOne(id);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Добавляем useCallback с пустым массивом зависимостей

    return { onGetAllNews, onGetOneNews };
};
